import EventEmitter from 'events'

class EventBus extends EventEmitter {
  emit (type) {
    console.log('[ NEXUS ] Event emitted : ' + type)
    super.emit.apply(this, arguments)
  }
}

export const events = new EventBus()



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/event-bus.js